import { apiTracking, apiUser } from "api"
import { notification } from "components/ui"
import useStore from "components/ui/Context"
import { setAccessToken, setRefreshToken } from "lib/Cookies"
import { useRouter } from "next/router"

const getTracking = () => (typeof window !== "undefined" ? window.TrackingLib : null)

export default function useCompleteLogin({ initView, onClose }) {
  const { setUser, togleModalLogin, isShowModalLogin, dataEvent, isRedirectEvent, setIsRedirectEvent } = useStore()
  const router = useRouter()
  const redirectParam = process.env.NEXT_PUBLIC_REDIRECT_ONPLUS
  const redirectValue = router.query[redirectParam]

  return async function completeLogin(authData, method) {
    if (!authData?.access_token || !authData?.refresh_token) {
      throw new Error("Dữ liệu đăng nhập không hợp lệ")
    }

    setAccessToken(authData.access_token)
    setRefreshToken(authData.refresh_token)

    const { data: user, success } = await apiUser.getMe()
    if (!success || !user) {
      throw new Error("Không thể tải thông tin tài khoản")
    }

    setUser(user)

    const tracking = getTracking()
    tracking?.setUserInfo({ userId: user.id })
    tracking?.trackEvent("user_login", {
      event_name: "user_login",
      user_id: user.id,
      login_method: method
    })

    try {
      await apiTracking.trackingSession({
        user_id: authData.user_id,
        event_name: "web_foreground",
        device_platform: 2
      })
    } catch (error) {
      console.log(error)
    }

    if (user.phone?.length < 1 || user.phone === null) {
      return { requiresPhoneUpdate: true }
    }

    notification.success({ message: "Đăng nhập thành công" })
    if (initView !== "updatephone" && isShowModalLogin) {
      togleModalLogin()
    } else {
      onClose?.()
    }

    if (router.route.includes("video")) {
      router.reload()
    } else if (isRedirectEvent) {
      await router.push(dataEvent?.link)
    } else if (redirectValue) {
      await router.push(redirectValue)
    } else {
      setIsRedirectEvent(false)
    }

    return { requiresPhoneUpdate: false }
  }
}
